<script lang="ts" setup>
import {useI18n} from 'vue-i18n'

export interface IDSKWarningTextProps {
  variant: 'info' | 'warning' | 'warningInfo' | 'warningInfoNoBtn'
  iconPresent?: boolean | undefined
}

const CLASS_ROOT = 'govuk-warning-text'

const props = withDefaults(defineProps<IDSKWarningTextProps>(), {
  variant: 'warning',
  iconPresent: true,
})

const {t} = useI18n()
const defaultIcons = {
  warning: '!',
  warningInfo: '!',
  warningInfoNoBtn: '!',
  info: 'i',
}
</script>

<template>
  <div v-if="props.variant=='warningInfo' || props.variant=='warningInfoNoBtn'"
       style="border: 2px solid rgba(168, 208, 227, .3)">
    <div :class="[CLASS_ROOT, { [`${CLASS_ROOT}--${props.variant}`]: props.variant }]" style="margin-bottom: 0px !important">
    <span v-if="props.iconPresent && props.variant!='warningInfo'" :class="`${CLASS_ROOT}__icon`" aria-hidden="true">
      <slot name="icon">{{ defaultIcons[props.variant] }}</slot>
    </span>
      <span v-if="props.iconPresent && props.variant=='warningInfo'" :class="`${CLASS_ROOT}__icon warning-with-border`"
            aria-hidden="true">
      <slot name="icon">{{ defaultIcons[props.variant] }}</slot>
    </span>
      <a v-if="props.variant=='warningInfo'"
         :class="`${CLASS_ROOT}__text ${!props.iconPresent ? 'pl-0 ml-4 mr-4' : ''}`">
      <span :class="`${CLASS_ROOT}__assistive`">
        <slot name="assistive">Doležité</slot>
      </span>
        <slot/>
      </a>
      <strong v-if="props.variant!='warningInfo'"
              :class="`${CLASS_ROOT}__text ${!props.iconPresent ? 'pl-0 ml-4 mr-4' : ''}`">
      <span :class="`${CLASS_ROOT}__assistive`">
        <slot name="assistive">Doležité</slot>
      </span>
        <slot/>
      </strong>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.warning-with-border {
  margin-left: 15px;
}

.govuk-warning-text-button {
  margin-top: -25px;
  margin-left: 20px;
}

.govuk-warning-text {
  border-radius: var(--radius-small);

  &--warning {
    background: var(--idsk-color-yellow);
    // background: yellow;
  }

  &--warning &__icon {
    margin-left: 10px;
    transform: scale(0.8);
    color: var(--idsk-color-yellow);
    // color: yellow;
  }

  &--info &__icon {
    border-color: #2b8cc4;
    background-color: #2b8cc4;
    border-width: 7px;
    margin-top: 0;
    transform: translateY(-50%);
  }

  &__text {
    padding-left: 60px;
  }
}

.pl-0 {
  padding-left: 0 !important;
}
</style>
